export enum TagType {
  User = 'User',
  Role = 'Role',
  RoleAssignment = 'RoleAssignment',
  DevicePairing = 'DevicePairing'
}

export type Tags = `${TagType}`

export const TagTypes = [
  TagType.User,
  TagType.Role,
  TagType.RoleAssignment,
  TagType.DevicePairing
] as TagType[]
